export enum LoginDevice {
	Desktop = 1,
	Mobile = 2
}

export enum LoginType {
	Id = 1,
	Location
}
